import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import EditText from '../../component/EditText';
import MyButton from '../../component/Button';
import moment from 'moment';
import { Get, Create } from './http';

class FormsElements extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: {
                phone: '',
                tel: '',
                fax: '',
                email: '',
                addr: '',
                office: '',
                account: '',
                phone2: '',
                tel2: '',
                fax2: '',
                email2: '',
                addr2: '',
                office2: '',
                account2: '',
            },
        };

        Get(this, res => {
            this.setState({ data: res });
        });
    }

    clickSave = e => {
        Create(this, this.state.data, res => {
            alert('저장이 완료 되었습니다.');
        });
    };

    render() {
        const { data } = this.state;

        return (
            <div>
                <Row>
                    <Col>
                        <Card className="white">
                            <Card.Header>
                                <Card.Title as="h5">{'법인 사업자 기본항목 정보'}</Card.Title>
                            </Card.Header>

                            <Card.Body>
                                <Row className="sort_input">
                                    <Col>
                                        <EditText
                                            title={'계산서 노출 휴대폰'}
                                            value={data.phone}
                                            placeholder="휴대폰번호를 입력하세요."
                                            onChange={e => {
                                                data.phone = e.target.value;
                                                this.setState(data);
                                            }}
                                        />
                                        <EditText
                                            title={'계산서 노출 팩스'}
                                            value={data.fax}
                                            placeholder="팩스번호를 입력하세요."
                                            onChange={e => {
                                                data.fax = e.target.value;
                                                this.setState(data);
                                            }}
                                        />
                                        <EditText
                                            title={'계산서 노출 사무실'}
                                            value={data.office}
                                            placeholder="사무실 정보를 입력하세요."
                                            onChange={e => {
                                                data.office = e.target.value;
                                                this.setState(data);
                                            }}
                                        />
                                        <EditText
                                            title={'계산서 노출 입금계좌'}
                                            value={data.account}
                                            placeholder="입금계좌를 입력하세요."
                                            onChange={e => {
                                                data.account = e.target.value;
                                                this.setState(data);
                                            }}
                                        />
                                    </Col>
                                    <Col>
                                        <EditText
                                            title={'계산서 노출 전화'}
                                            value={data.tel}
                                            placeholder="전화를 입력하세요."
                                            onChange={e => {
                                                data.tel = e.target.value;
                                                this.setState(data);
                                            }}
                                        />
                                        <EditText
                                            title={'계산서 노출 이메일'}
                                            value={data.email}
                                            placeholder="이메일을 입력하세요."
                                            onChange={e => {
                                                data.email = e.target.value;
                                                this.setState(data);
                                            }}
                                        />
                                        <EditText
                                            title={'계산서 노출 주소'}
                                            value={data.addr}
                                            placeholder="주소를 입력하세요."
                                            onChange={e => {
                                                data.addr = e.target.value;
                                                this.setState(data);
                                            }}
                                        />
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>

                        <Card className="white">
                            <Card.Header>
                                <Card.Title as="h5">{'일반 사업자 기본항목 정보'}</Card.Title>
                            </Card.Header>

                            <Card.Body>
                                <Row className="sort_input">
                                    <Col>
                                        <EditText
                                            title={'계산서 노출 휴대폰'}
                                            value={data.phone2}
                                            placeholder="휴대폰번호를 입력하세요."
                                            onChange={e => {
                                                data.phone2 = e.target.value;
                                                this.setState(data);
                                            }}
                                        />
                                        <EditText
                                            title={'계산서 노출 팩스'}
                                            value={data.fax2}
                                            placeholder="팩스번호를 입력하세요."
                                            onChange={e => {
                                                data.fax2 = e.target.value;
                                                this.setState(data);
                                            }}
                                        />
                                        <EditText
                                            title={'계산서 노출 사무실'}
                                            value={data.office2}
                                            placeholder="사무실 정보를 입력하세요."
                                            onChange={e => {
                                                data.office2 = e.target.value;
                                                this.setState(data);
                                            }}
                                        />
                                        <EditText
                                            title={'계산서 노출 입금계좌'}
                                            value={data.account2}
                                            placeholder="입금계좌를 입력하세요."
                                            onChange={e => {
                                                data.account2 = e.target.value;
                                                this.setState(data);
                                            }}
                                        />
                                    </Col>
                                    <Col>
                                        <EditText
                                            title={'계산서 노출 전화'}
                                            value={data.tel2}
                                            placeholder="전화를 입력하세요."
                                            onChange={e => {
                                                data.tel2 = e.target.value;
                                                this.setState(data);
                                            }}
                                        />
                                        <EditText
                                            title={'계산서 노출 이메일'}
                                            value={data.email2}
                                            placeholder="이메일을 입력하세요."
                                            onChange={e => {
                                                data.email2 = e.target.value;
                                                this.setState(data);
                                            }}
                                        />
                                        <EditText
                                            title={'계산서 노출 주소'}
                                            value={data.addr2}
                                            placeholder="주소를 입력하세요."
                                            onChange={e => {
                                                data.addr2 = e.target.value;
                                                this.setState(data);
                                            }}
                                        />
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>

                        <div className="voting_fixed_bottom">
                            <MyButton title={'저장하기'} variant="primary" onClick={this.clickSave} />
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default FormsElements;
